import Button from "shared/components/button";
import ButtonType from "shared/enums/ButtonTypes";
import FormContainer from "shared/form";
import FormTextField from "shared/form/fields/textField";
import { useCopies } from "shared/hooks/useCopies";
import useSearchNonAttendeeService from "./service";
import { SearchNonAttendeeRegistrationProps } from "./types";
import ButtonGroup from "shared/components/button/components/buttonGroup";

export default function SearchNonAttendeeRegistration(props: SearchNonAttendeeRegistrationProps) {
  const copies = useCopies();
  const service = useSearchNonAttendeeService(props);
  return (
    <FormContainer
      initialValues={service.initialValues}
      validationSchema={service.validationSchema}
      onSubmit={service.submitHandler}
      enableReinitialize>
      {() => {
        return (
          <FormContainer.Form>
            <FormTextField
              label={copies.get("work.email")}
              additionalLabel={props.additionalLabel}
              required
              name={"workEmail"}
              fullWidth
            />
            <ButtonGroup fullWidth className="assignTicketFooter">
              <Button label={copies.get("next")} type={ButtonType.SUBMIT} />
            </ButtonGroup>
          </FormContainer.Form>
        );
      }}
    </FormContainer>
  );
}
